import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingMessageProps {
  message?: string;
  className?: string;
  ariaLabel?: string;
}

export function LoadingMessage({ message = 'Ładowanie...', className, ariaLabel }: LoadingMessageProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={ariaLabel || 'Trwa ładowanie zawartości'}
      className={className}
    >
      <div className="flex justify-center items-center gap-3 py-8">
        <Loader2 className="w-6 h-6 animate-spin text-accessible-red-600" aria-hidden="true" />
        <span className="text-xl text-accessible-gray-600 dark:text-accessible-gray-300 high-contrast:text-white">
          {message}
        </span>
      </div>
    </div>
  );
}

export default LoadingMessage;


